import apiService from "@/lib/api";

const MATCH_RETRIGGER_BASE = "/api/v2/match-retrigger";

export const MatchRetriggerService = {
  /**
   * Reconciliation read for page reload / socket blip — same shape as the
   * per-item queue that drives the modal's progress strip.
   *
   * @param {string} batchId
   */
  getBatch: async (batchId) => {
    try {
      const response = await apiService.getSecure(`${MATCH_RETRIGGER_BASE}/batches/${batchId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching match retrigger batch:", error);
      throw error;
    }
  },

  /**
   * Powers the JD-update candidate picker modal — status groups (with
   * total/eligible counts over the FULL set) + a paginated, filtered
   * candidates[] list. Every candidate on the job is listed: a JD edit changes
   * the prompt for all of them equally, so there is nothing to single out.
   *
   * @param {string} jobId
   * @param {object} params - { search, statusIds: string[], page, perPage }
   */
  getJobRetriggerCandidates: async (jobId, params = {}) => {
    try {
      const { search, statusIds, page, perPage } = params;
      const response = await apiService.getSecure(
        `${MATCH_RETRIGGER_BASE}/job/${jobId}/candidates`,
        {
          params: {
            search: search || undefined,
            // Comma-joined — see router.py's comment: axios encodes array
            // params as statusIds[]=a&statusIds[]=b, which FastAPI's
            // list[str] Query does not parse.
            statusIds: statusIds?.length ? statusIds.join(",") : undefined,
            page: page || 1,
            perPage: perPage || 25,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching job retrigger candidates:", error);
      throw error;
    }
  },

  /**
   * The one enqueue endpoint for BOTH re-trigger paths — a candidate edit
   * posts a single applicationId, the JD picker posts many. Returns 202 +
   * the batch id; the work happens in the background.
   *
   * @param {object} payload - { triggerSource, jobId, applicationIds, changedFields, reason, selectionSummary }
   */
  createBatch: async (payload) => {
    try {
      const response = await apiService.postSecure(`${MATCH_RETRIGGER_BASE}/batches`, payload);
      return response.data;
    } catch (error) {
      console.error("Error creating match retrigger batch:", error);
      throw error;
    }
  },

  /**
   * Marks still-queued items CANCELLED; in-flight items finish.
   *
   * @param {string} batchId
   */
  cancelBatch: async (batchId) => {
    try {
      const response = await apiService.postSecure(`${MATCH_RETRIGGER_BASE}/batches/${batchId}/cancel`);
      return response.data;
    } catch (error) {
      console.error("Error cancelling match retrigger batch:", error);
      throw error;
    }
  },
};

export default MatchRetriggerService;
